import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import { NavLink } from '../common';
import { generalConstants } from '../../constants';

class Sidebar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sections:[{
        name: 'menu',
        label: 'Menu',
        icon:'fal fa-file-alt',
        collapse: true,
        menus: [
          {
            label: 'Home',
            url: generalConstants.URL+'home'
          },{
            label: 'Clients',
            url: generalConstants.URL+'clients'
          },{
            label: 'Projects',
            url: generalConstants.URL+'projects'
          },{
            label: 'About',
            url: generalConstants.URL+'about'
          }
        ]
      },{
        name: 'settings',
        label: 'Settings',
        icon: 'fal fa-cog',
        collapse: true,
        menus: [
          {
            label: 'SEO',
            url: generalConstants.URL+'seo'
          }
        ]
      }]
    }

    this.handleToggleCollapse = this.handleToggleCollapse.bind(this);
  }

  handleToggleCollapse(e) {
    const { sections } = this.state;
    let temp_sections = sections;

    temp_sections.find(function (object, index_s) { 
      
      if(object.name === e.target.name){
        console.log("target : ",object.name, e.target.name, temp_sections[index_s].collapse);
        temp_sections[index_s].collapse = !temp_sections[index_s].collapse;
      } 

    });

    this.setState({sections:temp_sections});
  }

  render() {
    const { sections } = this.state;

    return (
      <aside className="main-sidebar">
        
        {
          sections &&
          <section className="sidebar">
            <ul className="sidebar-menu" data-widget="tree">
            {
              sections.map((section, index_s)=>
                <li key={index_s} className={section.collapse ? 'treeview' : 'treeview menu-open'} onClick={ this.handleToggleCollapse }>
                  <Link to="#" name={section.name}>
                    <i className={section.icon} />
                    <span>{section.label}</span>
                    <span className="pull-right-container">
                      <i className="fa fa-angle-left pull-right" />
                    </span>
                  </Link>
                  <ul className="treeview-menu" style={section.collapse ? {display: 'none'} : {display: 'block'}}>
                    {
                      section.menus.map((menu, index_m)=>
                        <NavLink key={index_m} to={menu.url}>
                            {menu.label}
                        </NavLink>
                      )
                    }
                  </ul>
                </li>
                )
              }
            </ul>
          </section>
        } 
      </aside>
    );
  }
}

// function mapStateToProps(state) {
//   const { authentication } = state;
//   const { user } = authentication;
//   return {
//     user
//   };
// }

// const connectedSidebar = connect(mapStateToProps)(Sidebar);
Sidebar.contextTypes = {
  router: PropTypes.object
};
export { Sidebar };



// WEBPACK FOOTER //
// ./src/components/common/Sidebar.jsx